import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import LightTooltip from '../LightTooltip/LightTooltip';

const useStyles = makeStyles(() => ({
  texto: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0
  }
}));

/**
 * Texto en una línea con "..." si no entra; al pasar el mouse muestra el texto completo, sólo si quedó cortado.
 * title: lo que muestra el tooltip (por defecto el mismo contenido).
 */
const OverflowTooltip = ({ children, title, className, placement = 'top-start' }) => {
  const classes = useStyles();
  const ref = useRef(null);
  const [abierto, setAbierto] = useState(false);

  const mostrarSiEstaCortado = () => {
    const elemento = ref.current;
    setAbierto(!!elemento && elemento.scrollWidth > elemento.clientWidth);
  };

  return (
    <LightTooltip title={title || children} open={abierto} placement={placement}>
      <div
        ref={ref}
        className={className ? `${classes.texto} ${className}` : classes.texto}
        onMouseEnter={mostrarSiEstaCortado}
        onMouseLeave={() => setAbierto(false)}
      >
        {children}
      </div>
    </LightTooltip>
  );
};

export default OverflowTooltip;
